import {observable, action} from 'mobx';
import abortable from 'utils/abortable';
import makeAbortable from 'abortable-promise';

class IterableState {
  async postRequest(formData, campaignID, {isAborted}) {
    const {json} = await this.ctx.iterableSDK.post(`/add?campaign=${campaignID}`, formData);
    if (isAborted()) return;

    return json;
  }

  /*
   * POST request to Iterable via iterable-sdk
   */
  @action async post(formData, campaignID) {
    if (this.isLoading) return this.lastLoad;

    const _abortable = abortable();
    this.abort = _abortable.abort;

    this.isLoading = true;
    this.error = null;

    const {promise} = makeAbortable(this.postRequest(formData, campaignID, _abortable));
    this.lastLoad = promise;

    try {
      return await promise;
    } catch (error) {
      this.onError(error);
      throw error;
    } finally {
      this.always();
    }
  }

  @observable isLoading = false;
  @observable error = null;

  @action onError(error) {
    this.error = error;
  }
  @action always() {
    this.isLoading = false;
  }

  @action reset() {
    if (this.abort) this.abort();
    this.error = null;
    this.isLoading = false;
  }

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }
}

export default IterableState;



// WEBPACK FOOTER //
// ./spa/state/_util/iterable.jsx